// description

export function getCheapestVariant(variants) {
  return variants.reduce((prev, curr) => (parseInt(prev.price) < parseInt(curr.price) ? prev : curr));
}
